import {createTheme} from '@mui/material';
const defaultTheme = createTheme({});
export const theme = createTheme({
  palette: {
    secondary: {
      main: '#efefef'
    }
  }
});
if (process.env.REACT_APP_ENV === 'development') console.log(theme);
